export class ToastManager {
  private static container: HTMLElement | null = null;

  private static ensureContainer(): HTMLElement {
    if (!this.container) {
      this.container = document.createElement('div');
      this.container.id = 'toast-container';
      this.container.style.cssText = `
        position: fixed;
        bottom: 24px;
        right: 24px;
        z-index: 100000;
        display: flex;
        flex-direction: column;
        gap: 12px;
        pointer-events: none;
      `;
      document.body.appendChild(this.container);
    }
    return this.container;
  }

  static show(message: string, type: 'info' | 'success' | 'warning' | 'error' = 'info', duration = 3500): void {
    const container = this.ensureContainer();

    const toast = document.createElement('div');
    toast.style.cssText = `
      padding: 14px 20px;
      border-radius: 10px;
      color: #fff;
      font-size: 0.9rem;
      font-weight: 600;
      box-shadow: 0 10px 25px rgba(0,0,0,0.4);
      display: flex;
      align-items: center;
      gap: 10px;
      opacity: 0;
      transform: translateY(20px);
      transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
      pointer-events: auto;
      backdrop-filter: blur(8px);
    `;

    const colors = {
      info: 'background: rgba(30, 41, 59, 0.9); border: 1px solid #6366f1;',
      success: 'background: rgba(22, 101, 52, 0.9); border: 1px solid #22c55e;',
      warning: 'background: rgba(146, 64, 14, 0.9); border: 1px solid #f59e0b;',
      error: 'background: rgba(153, 27, 27, 0.9); border: 1px solid #ef4444;',
    };
    const icons = { info: 'ℹ️', success: '✅', warning: '⚠️', error: '❌' };

    toast.style.cssText += colors[type];
    toast.innerHTML = `<span>${icons[type]}</span> <span>${message}</span>`;

    container.appendChild(toast);

    requestAnimationFrame(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateY(0)';
    });

    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(20px)';
      setTimeout(() => toast.remove(), 300);
    }, duration);
  }
}
